"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.pick.title': 'Employee Onboarding',
    'onboarding.pick.description': 'Who do you want to assign new responsibilities to in your company?',
    'onboarding.pick.loading': 'Loading professions...',
};
